module.exports = __webpack_public_path__ + "images/stickers/taco-celebrate@2x.4cb46e9bd95fa7e041d5.png";